/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-12-01 11:50:01
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 21:28:38
 * @FilePath: /unifyxp-v2-store-portal/src/components/Slider/index.tsx
 */
import { useDebounceEffect, useDebounceFn } from 'ahooks';
import { isNumber } from 'lodash';
import Slider, { Range } from 'rc-slider';
import React from 'react';
import { OriNumberInput } from 'src/components/Antd';
import css from './css.module.less'; //

export { Slider, Range };

const NumberSlider = (props) => {
  const { min, max, value, onChange, suffix, disabled, onBlurOptimized } =
    props;
  const [_value, _setValue] = React.useState(value);

  useDebounceEffect(() => {
    if (value !== _value) {
      _setValue(value);
    }
  }, [value]);

  const { run: _onChange } = useDebounceFn(
    (v: any) => {
      onChange(v);
    },
    { wait: 1 },
  );

  return (
    <div className={css.container}>
      <Slider
        onChange={(v: any) => {
          _setValue(v);
          _onChange(v);
        }}
        startPoint={0}
        min={min}
        max={max}
        value={_value}
        className={css.slider}
        disabled={disabled}
        //trackStyle={{ backgroundColor: '#38C568' }}
      />
      <OriNumberInput
        value={_value}
        precision={0}
        {...(onBlurOptimized
          ? {
              onBlur: (e) => {
                const num = e.target.value;
                const valid = isNumber(+num);
                if (valid) {
                  _setValue(e.target.value);
                  _onChange(e.target.value);
                } else {
                  _setValue(0);
                  _onChange(0);
                }
              },
            }
          : {
              onChange: (e) => {
                console.log('e', e);

                const valid = isNumber(+e);
                if (valid) {
                  _setValue(e);
                  _onChange(e);
                } else {
                  // _setValue(0);
                  // _onChange(0);
                }
              },
            })}
        suffix={suffix || 'px'}
        min={min}
        max={max}
        size='large'
        className={css.numberInput}
        suffixClassName={css.suffixClassName}
        disabled={disabled}
      />
    </div>
  );
};
export default NumberSlider;
